import React, { Component } from 'react';
import { Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Layout from './Layout/Layout';
import AppRoute from '../containers/AppRoute';
import LoginLayout from './Layout/LoginLayout';
import Login from './Auth/Login';
import Logout from './Auth/Logout/Logout';
import Dashboard from './Dashboard/Dashboard';

import Objects from './Objects/Objects';
import Reports from './Reports/Reports';
import Eber from './Eber/Eber';
import OutletImport from './Outlet/OutletImport';
import RouterPage from './Pages/RouterPage';
import * as actions from '../store/actions/index';

import './App.css';

class App extends Component {

	componentDidMount() {
		this.props.onTryAutoSignup(this.props.expired);
		this.props.onFetchSetting();
	}

	render() {
		let routes = null;
		if (this.props.isAuthenticated) {
			routes = (
				<Switch>
					<AppRoute exact path="/logout" layout={Layout} component={Logout} />
					<AppRoute exact path="/outlet-import/:type/:user/:file" layout={Layout} component={OutletImport} />
					<AppRoute path="/reports/:ownerId" layout={Layout} component={Reports} />
					<AppRoute path="/eber/:clientId" layout={Layout} component={Eber} />
					<AppRoute path="/object/:classes" layout={Layout} component={Objects} />
					<AppRoute exact path="/page" layout={Layout} component={RouterPage} />
					<AppRoute exact path="/" layout={Layout} component={Dashboard} />
					<Redirect to="/" />
				</Switch>
			);
		}
		else {
			routes = (
				<Switch>
					<AppRoute exact path="/login" layout={LoginLayout} component={Login} />
					<Redirect to="/login" />
				</Switch>
			)
		}

		return (
			<div>
				{routes}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		expired: state.auth.expired
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onTryAutoSignup: (expired) => dispatch(actions.authCheckState(expired)),
		onFetchSetting: () => dispatch(actions.settingFetch()),
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));